module.exports = __webpack_public_path__ + "static/logo-talk-of-the-town-6ac49b5d1b2f9a280a7cfc653d956d6f.png";